<ng-container *ngIf="loading">
  <div class="container-with-loading">
      <div class="loading-overlay">
          <mat-spinner></mat-spinner>
      </div>
  </div>
</ng-container>


<mat-card appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
      <mat-card-title>Usuario</mat-card-title>
    </mat-card-header-->
    <mat-card-content>
      <form class="form-container" (ngSubmit)="onSubmit(userForm)" #userForm="ngForm" >
        <mat-card class="general-wf-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Datos Generales</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div id="container" class="formControl">
              <div class="control">
                <mat-form-field class="controlWidth">
                    <mat-label>Correo</mat-label>
                    <input type="email" matInput placeholder="Ex. pat@example.com" name="user.email" [(ngModel)]="user.email">
                    <mat-error>{{ violations['user.email'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Nombre</mat-label>
                    <input matInput type="text" name="user.person.name" [(ngModel)]="user.person.name">
                    <mat-error>{{ violations['user.person.name'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Apellido Paterno</mat-label>
                  <input matInput type="text" name="user.person.paternalSurname" [(ngModel)]="user.person.paternalSurname">
                  <mat-error>{{ violations['user.person.paternalSurname'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Apellido Materno</mat-label>
                  <input matInput type="text" name="user.person.maternalSurname" [(ngModel)]="user.person.maternalSurname">
                  <mat-error>{{ violations['user.person.maternalSurname'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Telefono</mat-label>
                  <input matInput type="text" name="user.person.telephone" [(ngModel)]="user.person.telephone">
                  <mat-error>{{ violations['user.person.telephone'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Cel</mat-label>
                  <input matInput type="text" name="ouser.person.cellPhone" [(ngModel)]="user.person.cellPhone">
                  <mat-error>{{ violations['user.person.cellPhone'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="example-full-width">
                  <mat-label>Fecha Nacimiento</mat-label>
                  <input matInput [matDatepicker]="picker"  name="user.person.dateOfBirth" [(ngModel)]="user.person.dateOfBirth">
                  <!--mat-hint>MM/DD/YYYY</mat-hint-->
                  <mat-datepicker-toggle matIconSuffix [for]="picker"> </mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error>{{ violations['user.person.dateOfBirth'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-slide-toggle [(ngModel)]="user.active" name="user.active"> {{ user.active? 'Activo':'Inactivo'}} </mat-slide-toggle>
              </div>
            </div>
          </mat-card-content>
          <mat-card-footer class="general-wf-card-footer">
          </mat-card-footer>
        </mat-card>
        <br>
        <mat-card class="general-wf-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Roles</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <section class="example-section">
              @for (role of roles; track role.name; let idx = $index) {
                <mat-checkbox
                  class="example-margin"
                  [(ngModel)]="role.checked"
                  [id]="'roles[' + idx + ']'"
                  [name]="'roles[' + idx + ']'"  (change)="isRolAutCheck()" >
                  {{ role.description }}
                </mat-checkbox>
              } @empty {
                <li>There are no items.</li>
              }
            </section>
          </mat-card-content>
        </mat-card>
        <br>
        @if(isRolAut){
        <mat-card appearance="outlined">
          <mat-card-header>
              <mat-card-title>Divisiones y Areas</mat-card-title>
            </mat-card-header>
          <mat-card-content>
            <table class="table-div-area">
              <thead>
                <tr>
                  <th>División / Área</th>
                    @for (area of areas; track area.id) {
                     <th>{{ area.description }}</th>
                    }
                </tr>
              </thead>
              <tbody> 
                @for (division of divisions; track division.id; let rowIndex = $index) {
                  <tr [class.hovered-row]="hoveredRow === rowIndex">
                    <td>{{ division.description }}</td>
                    @for (area of areas; track area.id; let colIndex = $index) {
                      <td [class.hovered-col]="hoveredCol === colIndex"
                          (mouseenter)="onMouseEnter(rowIndex, colIndex)"
                          (mouseleave)="onMouseLeave()">
                          <input type="checkbox" [checked]="isSelected(division.id, area.id)"
                                (change)="onCheckboxChange(getSDA(division.id, area.id), $event)"
                          />
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </mat-card-content>
        </mat-card>
        }
        <br>
        <div class="formControl">
          <div class="control">
            <button mat-flat-button class="button buttonWidth">
              {{(user.id > 0)? 'Actualizar': 'Crear'}}
            </button>
          </div>
        </div>
        <br>
      </form>
    </mat-card-content>
  <mat-card-footer class="general-wf-card-footer">
  </mat-card-footer>
</mat-card>
